module.exports = __webpack_public_path__ + "img/744.c0b9e02e.jpg";